/* @flow */
import React, { useContext } from 'react';
import classnames from 'classnames';

import { TileContext } from '../helpers/TileContext';
// Styles
import styles from './styles.scss';

// Types
type TitleProps = {|
    creationDate?: string | null,
    creatorName?: string | null,
    disableLinks?: boolean,
    isArt?: boolean,
    pdpUrl: string,
    title: string,
    onClick?: () => void,
    titleOneLine: boolean,
|};

function Title(props: TitleProps) {
    const { imageSize } = useContext(TileContext);
    const {
        isArt,
        creatorName,
        creationDate,
        disableLinks,
        pdpUrl,
        onClick,
        title,
        titleOneLine,
    } = props;

    const titleEl = isArt ? (
        <h2 className={styles.title}>
            {creatorName && (
                <div className={styles.ellipsis} data-tn="portfolio-row-creator-name">
                    {creatorName}
                </div>
            )}
            <div
                className={classnames(styles.artOneLine, {
                    [styles.hasBottomMargin]: !creatorName,
                })}
            >
                <span className={styles.ellipsis} data-tn="portfolio-row-product-name">
                    {title}
                </span>
                {creationDate && `, ${creationDate}`}
            </div>
        </h2>
    ) : (
        <h2
            className={classnames(styles.title, { [styles.ellipsis]: titleOneLine })}
            data-tn="portfolio-row-product-name"
        >
            {title}
        </h2>
    );

    if (disableLinks) {
        return <span className={classnames(styles.link, styles[imageSize])}>{titleEl}</span>;
    }

    return (
        <a
            className={classnames(styles.link, styles[imageSize])}
            data-tn="item-title-link"
            href={pdpUrl}
            onClick={onClick}
        >
            {titleEl}
        </a>
    );
}

Title.defaultProps = {
    disableLinks: false,
};

export default Title;
